export const unreadCountScreenReaderOnlyText = "$od";
export default {unreadCountScreenReaderOnlyText};